import {
  SET_AGENT_REQUEST_PAYMENT_PLAN,
  SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS,
  SET_AGENT_REQUEST_PERSONAL_INFO_LIST,
  SET_E_CARD_AVATAR,
  SET_E_CARD_INFO,
  SET_E_CARD_PERSONAL_BUSINESS_INFO,
  SET_E_CARD_QR_IMAGE,
} from '@stores/myprofile/constants.js';

export const initialState = {
  eCardInfo: {},
  eCardPersonalBusinessInfo: {},
  eCardAva: '',
  eCardQrImage: '',
  agentRefOtpId: '',
  agentRequestPersonalInfoList: {},
  agentRequestPersonalInfoDetails: [],
  agentRequestPaymentPlanList: {},
};

const myProfileReducers = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_E_CARD_INFO:
      state = {
        ...state,
        eCardInfo: payload,
      };
      break;
    case SET_E_CARD_PERSONAL_BUSINESS_INFO:
      state = {
        ...state,
        eCardPersonalBusinessInfo: payload,
      };
      break;
    case SET_E_CARD_AVATAR:
      state = {
        ...state,
        eCardAva: payload,
      };
      break;
    case SET_E_CARD_QR_IMAGE:
      state = {
        ...state,
        eCardQrImage: payload,
      };
      break;
    case SET_AGENT_REQUEST_PERSONAL_INFO_LIST:
      state = {
        ...state,
        agentRequestPersonalInfoList: payload,
      };
      break;
    case SET_AGENT_REQUEST_PAYMENT_PLAN:
      state = {
        ...state,
        agentRequestPaymentPlanList: payload,
      };
      break;
    case SET_AGENT_REQUEST_PERSONAL_INFO_DETAILS:
      state = {
        ...state,
        agentRequestPersonalInfoDetails: payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export default myProfileReducers;
